import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fa8545f6558f0014ba8433_1783780818845_838def93/tryink/src/app/sign-up-login-screen/components/AuthScreen.tsx");
